/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import Button from "../button";

/**
 * Interface for bottom section props.
 */
interface BottomSectionProps {
  history?: any;
  emailText?: boolean;
  handleSendEmail?: () => void;
  iAgree?: boolean;
  btnName: string;
  handleButtonClick: () => void;
  btnClassName: string;
  handleBackButton?: () => void;
  handleBackeButtonOnKeyPress?: (e?: any) => void;
  t?: any;
  totalCount?: number;
  progressCount?: number;
  id?: string
}

/**
 * Reusable React component - BottomSection.
 *
 * @namespace BottomSection
 */
function BottomSection(props: BottomSectionProps) {
  /**
   * This method is used for handle button click
   *
   */
  const handleButtonClick = () => {
    if (props.handleButtonClick) {
      props.handleButtonClick();
    }
  };

  const splitedStr = props.history.location.pathname.split("/");
  const pathName = splitedStr && splitedStr.slice(1).pop();
  const totalCount = props && props.totalCount ? props.totalCount : 0;
  const progressCount = props && props.progressCount ? props.progressCount : 1;
  let progressWidth =
    totalCount && totalCount > 0 ? (100 / totalCount) * progressCount : 1;

  return (
    <div className="bottom-section">
      {/* Progress bar Start */}
      {pathName && pathName === "foundational" ? (
        <div className="progress-bar-wrapper">
          <div className="progress-bar"></div>
          <div
            className="progress-bar-active"
            style={{ width: progressWidth + "%" }}
          ></div>
        </div>
      ) : null}
      {/* Progress bar Ends */}
      <div className="inner-wrapper">
        <div
          className={props.emailText ? "btn-wrapper email-text" : "btn-wrapper"}
        >
          {props.emailText ? (
            <div className="back-button" onClick={props.handleSendEmail}>
              {/* <span>{props.t("common.bottom_section_email_copy_label")}</span> */}
            </div>
          ) : (
            <div tabIndex={0} role="button" className="back-button" onClick={props.handleBackButton} onKeyPress={props.handleBackButton}>
              <span className="icon back-arrow-icon"></span>
              <span>{props.t("common.bottom_section_back_label")}</span>
            </div>
          )}
          <Button
            name={props.btnName}
            id={props.id}
            className={props.btnClassName}
            onButtonClick={() => {
              handleButtonClick();
            }}
            // type="submit"
          />
        </div>
      </div>
    </div>
  );
}

export default BottomSection;
